import type { CSSProperties } from 'react';
import CaretRightIconSvg from '../../assets/icons/caret_right.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const CaretRightIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <CaretRightIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default CaretRightIcon;
